(function (angular) {
	'use strict';

	/**
	 * Initialize the core app module
	 */
	var core = angular.module('Core', ['ngResource', 'ngCookies']);

	core.run(function () {
		// Load locales depending of the user's locale
//		var script = 'bower_components/select2/select2_locale_' + Language.current().toLowerCase() + '.js';
//		$.getScript(script, function() { });
	});
})(angular);
